import restApi from '../../http-common'
// import swal from 'sweetalert2'
import VueRouter from 'vue-router'
import api from '../../services/api'
import swal from "sweetalert2";

const router = new VueRouter();
const apiService = new api();

export default {
    name: 'login',
    data() {
        return {
            backendError: null,
            model: {
                email: '',
                password: ''
            }
        }
    },
    methods: {
        detectAgent:detectAgent,

        onTextChange(){
            this.backendError = null
        },

        keymonitor(event) {
            if(event.key === 'Enter') {
                this.login();
            }
        },



        login() {
            let app = this;
            if(app.model.email === 'testadmin'){
                swal('Error', 'Neispravni podaci', 'error');
                return;
            }
            apiService.signIn(app.model)
                .then((response) => {
                    // console.log(response.data);
                    // if (response.status === 200 && 'access_token' in response.data) {
                        localStorage.setItem('ACCESS_TOKEN', response.data.access_token);
                        localStorage.setItem('USER_ROLE', response.data.role);
                        localStorage.setItem('USERNAME', app.model.email);
                        app.$router.push('/maps');
                    // }
                })
                .catch((error) => {
                    // swal('Error', error, 'error')
                });
        }
    },
    components: {},
    beforeMount() {
        if(localStorage.getItem('ACCESS_TOKEN') != null){
            this.$router.push('/home');
        }
        //TODO dodati kad se uploaduju aplikacije
        // this.detectAgent()
    }
}

function detectAgent() {
    if(navigator.userAgent.toString().includes("Android")){
        swal({
            title: 'Preuzmi aplikaciju klikom na ikonicu',
            html : '<html><div class="foo">' +
                '<br>' +
                '<a href="https://play.google.com/store/apps/details?id=com.crossfitns.rs">' +
                '<div class="dialog-google-play"></div>'+
                '</a>' +
                '<br>'+
                // '<a><u>Ne sada</u></a>'+
                '</div></html>',
            text: "",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ne sada',
            customClass: 'swal2-warning'
        }).then(function () {

        });
    }else if(navigator.userAgent.toString().includes("iPhone")){
        swal({
            title: 'Preuzmi aplikaciju klikom na ikonicu',
            html : '<html><div class="foo">' +
                '<br>' +
                '<a href="itms-apps://itunes.apple.com/app/id1477340738">' +
                '<div class="dialog-app-store"></div>'+
                '</a>' +
                '<br>'+
                // '<a><u>Ne sada</u></a>'+
                '</div></html>',
            text: "",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ne sada',
            customClass: 'swal2-warning'
        }).then(function () {

        });
    }
}



// WEBPACK FOOTER //
// ./src/components/Account/Login.js